import { Divider, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useNotify,
  useRefresh,
  useShowContext,
} from 'react-admin'
import Button from '../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import { getContrastColor } from '../../../../core/common/visual.utils'
import { DoorReleaseDialog } from '../../doors/DoorDialogs'

const useStyle = makeStyles({
  divider: {
    height: 1,
    width: '100%',
  },
})

export const DoorReleaseManagementButton = ({ ...props }) => {
  const { color, door, fontSizeClass } = props
  const classes = useStyle()
  const notify = useNotify()
  const hasAuthority = useHasAuthority()
  const { loading } = useShowContext()
  const [stateDialogOpen, setStateDialogOpen] = useState(false)
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()

  const handleCloseDialog = () => {
    setStateDialogOpen(false)
  }

  const handleOpenDialog = () => {
    setStateDialogOpen(true)
  }

  const handleSetReleased = async (released: boolean) => {
    handleCloseDialog()
    await mutate(
      {
        type: sanitizeFetchType('setDoorReleased'),
        resource: ResourceName.DOORS,
        payload: {
          doorId: door?.id,
          released,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
    refresh?.()
  }

  return (
    <>
      <DoorReleaseDialog
        open={stateDialogOpen}
        close={handleCloseDialog}
        handleSetReleased={handleSetReleased}
      />
      <Button
        variant="text"
        className={fontSizeClass}
        style={{ color: getContrastColor(color) }}
        label="resources.doors.actions.setState"
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.DOORS_SET_RELEASE) ||
          loading ||
          mutationLoading
        }
        onClick={handleOpenDialog}
        fullWidth
      />
      <Divider className={classes.divider} />
    </>
  )
}
